import React from "react";
import "./Pricing.css";
import check from "../../assets/images/Lp/check-gd.png";

const Box_data = [
  {
    id: 1,
    name: "Starter Plan",
    desc: "Up to 2,500 monthly orders",
    price: "$9.99",
  },
  {
    id: 2,
    name: "Pro Plan",
    desc: "2,501 to 5,000 orders",
    price: "$19.99",
  },
  {
    id: 3,
    name: "Elite Plan",
    desc: "Over 5,000 orders",
    price: "$29.99",
  },
];
export default function Pricing({ id }) {
  return (
    <div id={id} className="section py-constant">
      <div className="container">
        <div className="subtitle">Pricing</div>

        <h2 className="h2    title center">
          Get an instant return
          <span className="accent"> on your investment</span>
        </h2>

        <div className="text-md text-width">
          Our pricing is simple. All features are included in each plan, and
          pricing only varies based on order volume (it costs us more to serve a
          store with more orders):
        </div>

        <div className="price-dt">
          <div className="list-item">
            <span
              style={{
                backgroundImage: `url(${check})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            />
            Real-time monitoring of discount code usage
          </div>
          <div className="list-item">
            <span
              style={{
                backgroundImage: `url(${check})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            />
            Automatic order cancellation and refund for suspicious orders
          </div>
          <div className="list-item">
            <span
              style={{
                backgroundImage: `url(${check})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            />
            Integration with Recharge / Shipstation
          </div>
          <div className="list-item">
            <span
              style={{
                backgroundImage: `url(${check})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            />
            Quick 2 minute installation with your existing Shopify set-up
          </div>
          <div className="list-item">
            <span
              style={{
                backgroundImage: `url(${check})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            />
            Comprehensive reporting and analytics
          </div>
        </div>

        <div className="flex flex-row price-inner">
          {Box_data.map((item) => {
            return (
              <div className="price-box">
                <span className="name">{item.name}</span>
                <div className="text-md">{item.desc}</div>
                <span className="price">
                  <span>{item.price}</span>
                  <small>/month</small>
                </span>
              </div>
            );
          })}
        </div>

        <a
          href="https://apps.shopify.com/customergenius"
          className="button button--primary bottom"
        >
          Start Catching Abusers Today with a 14 Day Free Trial!
        </a>
      </div>
    </div>
  );
}
